import Vue from 'vue';
import '@/registerServiceWorker';

import VirtualList from 'vue-virtual-scroll-list';

// includes an "install" named export emulating plugin behavior
import PortalVue from 'portal-vue';
import MdsIcon from '@mds/icon';
import { MdsButton } from '@mds/button';
import MdsModal from '@mds/modal';
import MdsLoader from '@mds/loader';
import InternalProcessLayout from '@/components/templates/InternalProcessLayout';
import ChangeStatus from '@/components/organisms/ChangeStatus';
import AllClientChangeStatus from '@/components/organisms/AllClientChangeStatus';
import Approve from '@/components/organisms/Approve';
import ExportData from '@/components/molecules/ExportData';
import ExportPendingData from '@/components/molecules/ExportPendingData';
import SubmitChanges from '@/components/molecules/SubmitChanges';
import SubmitReplacements from '@/components/molecules/SubmitReplacements';
import SubmitReplacementsNew from '@/components/molecules/SubmitReplacementsNew';
import LineupSubmitChanges from '@/components/molecules/LineupSubmitChanges';
import UndoChanges from '@/components/atoms/UndoChanges';
import UndoReplacements from '@/components/molecules/UndoReplacements';
import UndoReplacementsNew from '@/components/molecules/UndoReplacementsNew';
import AllFiduciaryFundStatus from '@/components/molecules/AllFiduciaryFundStatus';
import LineupUndoChanges from '@/components/atoms/LineupUndoChanges';
import Notification from '@/components/atoms/Notification';
import Pages from '@/components/atoms/Pages';
import SelectReplacement from '@/components/organisms/SelectReplacement';
import SelectReplacementNew from '@/components/organisms/SelectReplacementNew';
import MenuList from '@/components/organisms/MenuList';
import ProductMenuReplacement from '@/components/organisms/ProductMenuReplacement';
import App from '@/App';

import reCaptchaLoader from '@/plugins/recaptcha';
import * as $request from '@/plugins/fetch';

import store from '@/store';
import router from '@/router';

// disable an annoying "You are running Vue in development mode" message
Vue.config.productionTip = false;
Vue.config.devtools = true;

// inject the fetch controller into components as this.$request
Vue.use($request);
Vue.use(PortalVue);

// inject the VueReCaptcha third party component
reCaptchaLoader(Vue, store);

Vue.component('virtual-list', VirtualList);

// Register global MDS components
Vue.component('mds-icon', MdsIcon);
Vue.component('mds-button', MdsButton);
Vue.component('mds-loader', MdsLoader);
Vue.component('mds-modal', MdsModal);

// Register global components for FullscreenModal
Vue.component('internal-process', InternalProcessLayout);
Vue.component('change-status', ChangeStatus);
Vue.component('all-client-change-status', AllClientChangeStatus);
Vue.component('approve', Approve);
// Register global components for Modal
Vue.component('export-data', ExportData);
Vue.component('export-pending-data', ExportPendingData);
Vue.component('submit-changes', SubmitChanges);
Vue.component('submit-replacements', SubmitReplacements);
Vue.component('submit-replacements-new', SubmitReplacementsNew);
Vue.component('all-fiduciary-fund-status', AllFiduciaryFundStatus);
Vue.component('undo-changes', UndoChanges);
Vue.component('undo-replacements', UndoReplacements);
Vue.component('undo-replacements-new', UndoReplacementsNew);
Vue.component('lineup-undo-changes', LineupUndoChanges);
Vue.component('lineup-submit-changes', LineupSubmitChanges);
Vue.component('pages', Pages);
Vue.component('select-replacement', SelectReplacement);
Vue.component('select-replacement-new', SelectReplacementNew);
Vue.component('menu-list', MenuList);
Vue.component('product-menu-replacement', ProductMenuReplacement);
Vue.component('notification', Notification);

const isDev = process.env.NODE_ENV !== 'production';
Vue.config.performance = isDev;

new Vue({
  router,
  store,
  cacheBusting: false,
  render: (h) => h(App),
}).$mount('#app');
